module.exports = __webpack_public_path__ + "static/media/points-icon.1d3e84ed.svg";